import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    modalOverlay: {
        backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    headerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemContainer: {
        backgroundColor: "transparent",
        flexDirection: "row",
        alignItems: "center"
    },
    modalActions: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    listHeaderRow: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    balanceContainer: {
        justifyContent: "center",
        alignItems: "flex-start",
        minWidth: 250,
        ...webStyle({
            userSelect: "none"
        })
    },
    itemIcon: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    emptyListContent: {
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1
    },
    paginationContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    itemInfo: {
        flexDirection: "column",
        flex: 1
    },
    itemAmount: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    dateFilterRow: {
        flexDirection: "row",
        zIndex: 10
    },
    filterRow: {
        flexDirection: "row",
        zIndex: 10
    },
    itemActions: {
        flexDirection: "row",
        alignItems: "center"
    },
    jumpContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    actionsRow: {
        flexDirection: "row"
    },
    modalContent: {
        maxHeight: "90%",
        maxWidth: "90%",
        width: 500
    },
    jumpInputContainer: {
        width: 80
    },
    selectBoxLabel: {
    },
    formContainer: {
    },
    dateFilterCol: {
        flex: 1
    },
    jumpInput: {
        height: 48
    },
    listContent: {
    },
    filterCol: {
        flex: 1
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
